<template>
  <div class="container_login">
    <div class="card">
      <h1 class="card-title">金创视频智慧监控大屏</h1>
      <form class="card-form">
        <label for="username">账号</label>
        <div class="card-input-container username">
          <img class="img_icon" src="@/assets/img/account.png" />
          <input v-model="username" type="text" placeholder="请输入账号" id="username">
        </div>
        <label for="password">密码</label>
        <div class="card-input-container password">
          <img class="img_icon" src="@/assets/img/password.png" />
          <input v-model="password" type="password" placeholder="请输入密码" id="password">
        </div>
        <div @click="doLogin" class="card-button" :class="{ disabled: loading }">登 录</div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  mounted() {

  },
  methods: {
    doLogin() {
      let username = this.username;
      if (!username) {
        return this.swalToast('请输入账号')
      }
      let password = this.password;
      if (!password) {
        return this.swalToast('请输入密码')
      }
      let _this = this;
      if (_this.loading) return;
      _this.loading = true;
      axios.post(_this.$store.state.base_url + 'Monitor_Center/doLogin', {
        username, password
      }).then(function (response) {
        _this.loading = false;
        if (response.status === 200 && response.data.code == 1) {
          _this.swalToast('登录成功');
          localStorage.setItem('app-token', response.data.data.token);
          localStorage.setItem('app-user-info', JSON.stringify(response.data.data));
          _this.$store.dispatch("doChangeUserInfo", response.data.data);
          _this.$store.dispatch("changeDispatch", response.data.data.token);
        } else {
          _this.swalToast(response.data.info || '登录失败')
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.swalToast(error.toString());
      }).finally(function () { });
    },
    swalToast(message, icon = 'warning') {
      this.$swal({
        position: 'center',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: 1000,
        width: 200
      });
    }
  }
}
</script>

<style scoped>
.container_login {
  background: #0b1120;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, Helvetica, sans-serif;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #0f172a;
  width: 100%;
  max-width: 400px;
  padding: 40px 32px;
  border-radius: 16px;
  border: 1px solid #1e293b;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.card-title {
  font-size: 28px;
  font-weight: 600;
  color: #e2e8f0;
  margin-bottom: 8px;
  letter-spacing: 2px;
}

.card-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-top: 24px;
}

.card-input-container {
  position: relative;
  margin: 8px 0 20px;
  width: 100%;
}

.card-form label {
  color: #94a3b8;
  font-size: 13px;
  font-weight: 500;
}

.card-input-container input::placeholder {
  color: #475569;
}

.card-input-container input,
.card-button {
  width: 100%;
  border: none;
  outline: none;
  border-radius: 8px;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, Helvetica, sans-serif;
  box-sizing: border-box;
}

.card-input-container input {
  position: relative;
  z-index: 1;
  padding: 12px 16px 12px 48px;
  font-size: 14px;
  color: #e2e8f0;
  background: #1e293b;
  border: 1px solid #334155;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.card-input-container input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.card-button {
  background: #3b82f6;
  padding: 12px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  transition: background 0.3s;
  text-align: center;
}

.card-button:hover {
  background: #2563eb;
}

.card-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.card-input-container .img_icon {
  position: absolute;
  width: 18px;
  height: 18px;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  opacity: 0.5;
}
</style>
